/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_RsuAwardListDto } from '../models/PagedResultDto_RsuAwardListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RsuAwardLegacyService {

    /**
     * @param approvalStatusIds
     * @param employeeStatuses
     * @param rsuStatus
     * @param rsuAcceptance
     * @param createdFromDate
     * @param createdToDate
     * @param grantFromDate
     * @param grantToDate
     * @param approvedFromDate
     * @param approvedToDate
     * @param publishFromDate
     * @param publishToDate
     * @param awardTypeFilter
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_RsuAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppRSUAwardLegacyRSUAwardListOptimized(
        approvalStatusIds?: Array<number>,
        employeeStatuses?: Array<number>,
        rsuStatus?: number,
        rsuAcceptance?: number,
        createdFromDate?: string,
        createdToDate?: string,
        grantFromDate?: string,
        grantToDate?: string,
        approvedFromDate?: string,
        approvedToDate?: string,
        publishFromDate?: string,
        publishToDate?: string,
        awardTypeFilter?: string,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_RsuAwardListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/r-sUAward-legacy/r-sUAward-list-optimized',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'EmployeeStatuses': employeeStatuses,
                'RSUStatus': rsuStatus,
                'RSUAcceptance': rsuAcceptance,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'ApprovedFromDate': approvedFromDate,
                'ApprovedToDate': approvedToDate,
                'PublishFromDate': publishFromDate,
                'PublishToDate': publishToDate,
                'AwardTypeFilter': awardTypeFilter,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
